"use strict";

import $ from "jquery";

class SearchFilterManager
{
    constructor(container = "[data-search-role='results']",
                indicator = "[data-search-role='indicator']",
                filters = "[data-search-role='filters']") {

        // Results, indicator and indicator target.
        this.container = $(container);
        this.indicator = $(indicator);
        this.filters = $(filters);
        this.panel     = this.container.find("div.indicator-target");

        // Existing query string.
        this.urlState = this.getQuery(document.location.search);

        // Base and previous url.
        this.url = {
            base: [window.location.protocol, '//', window.location.host, window.location.pathname].join(''),
            prev: window.location.href
        };

        //set any filters to ignore when working out the active state
        this.ignoreFilters = ['origins', 'source', 'prodtypes', 'page', 'attractions', 'find', 'xhr', 'when'];

        this.setFiltersActive();
    }

    /**
     * Unsets multiple filters at once
     */
    unsetFilters(keys) {
        keys.forEach(this.unsetFilter, this);
    }

    /**
     * Unsets a single filter
     */
    unsetFilter(key) {
        if (key in this.urlState) {
            delete this.urlState[key];
        }
        this.setFiltersActive();
    }

    setFilter(key = "", value = "", remove = false) {
        // Remove non filtering params.
        this.unsetFilters(["page", "source", "prodtypes"]);

        if (
            key in SearchFilterManager.defaults &&
            value == SearchFilterManager.defaults[key]
            ) {
            // Key is default value - just remove it
            return this.unsetFilter(key);
        }

        if (Array.isArray(value)) {
            // Value is array - many values allowed per key
            if (remove &&
                key in this.urlState &&
                this.urlState[key].indexOf(value[0]) !== -1
            ) {
                // Key already exists - remove by splicing
                this.urlState[key].splice(
                    this.urlState[key].indexOf(value[0]),
                    1
                );
            }
            else {
                if (key in this.urlState) {
                    // Push new value
                    this.urlState[key].push(value[0]);
                }
                else {
                    // Add key + value
                    this.urlState[key] = value;
                }
            }

            // Remove entire key if no items
            if (!this.urlState[key].length) {
                this.unsetFilter(key);
            }
        }
        else {
            // Value is scalar - only one value allowed per key
            if (remove) {
                this.unsetFilter(key);
            }
            else {
                this.urlState[key] = value;
            }
        }
        this.setFiltersActive();
    }

    getQuery(value) {
        let parts = value.trim().replace(/^\?/, "").split("&"),
            query = {},
            reArray = /\[\d*\]$/;

        value = value.trim();

        if (value === "" || value === "?") {
            return query;
        }

        parts.forEach((part) => {
            let pair = part.split("="),
                key = decodeURIComponent(pair[0]),
                val = decodeURIComponent(pair[1]);

            if (pair.length === 2) {
                if (query[key] || reArray.test(key)) {
                    key = key.replace(reArray, "");

                    if (query[key] && !Array.isArray(query[key])) {
                        query[key] = [query[key]];
                    }
                    else if (! query[key]) {
                        query[key] = [];
                    }

                    query[key].push(val);
                }
                else {
                    query[key] = val;
                }
            }
            else {
                query[key] = "";
            }
        });

        return query;
    }



    /**
     * If any filters are set add a class to the filter container
     */
    setFiltersActive() {
        if(this.hasActiveFilters()) {
            this.filters.addClass('filters-set');
        }
        else this.filters.removeClass('filters-set');
    }

    /**
     * Check if there are any active filters set
     */
    hasActiveFilters() {
        if ($.isEmptyObject(this.urlState)) {
            // if nothing is in the url return false
            return false;
        } else {
            for (let key in this.urlState) {
                // if the current param is not in the list of ignored ones, return true
                if (this.ignoreFilters.indexOf(key) === -1) {
                    return true;
                }
            }
            return false;
        }
    }
}

SearchFilterManager.defaults = {
    duration: "remove",
    groups: "remove",
    price_min: "0",
    price_max: "7000"
};

export default (new SearchFilterManager());
